import React, {useCallback, useContext, useEffect, useState} from 'react';
import './ProfilePhoto.scss';
import {DeleteIcon, PersonBoxIcon} from "../../../../image";
import {Tooltip} from "antd";
import {PersonGray} from "../../../../image";
import DeleteProfilePhotoModal from "../DeleteProfilePhotoModal/DeleteProfilePhotoModal";
import classNames from "classnames";
import {
    DeleteDescriptorService,
    GetDescriptorsService,
    GetPersonById,
    UpdateMainDescriptorService
} from "../../../../redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {generateMediaUrl} from "../../../../utils/generateMediaUrl";
import {ToastContext} from "../../../Toast/ToastContext";
import {useTranslation} from "react-i18next";
import {hasPermission} from "../../../../utils/helperFunctions";
import {ROLE_ITEMS} from "../../../../utils/constants";

const ProfilePhoto = ({user}) => {
    const [isVisibleModal, setIsVisibleModal] = useState(false);
    const toggleIsVisibleModal = useCallback(() => setIsVisibleModal((prev) => !prev), []);
    const dispatch = useDispatch();
    const avatars = useSelector(state => state.profile.descriptors?.results || []);
    const profileId = user?.person_id || user?.attached_person?.id;
    const [selectAvatar, setSelectAvatar] = useState(null);
    const countAvatars = avatars?.length >= 10 ? 10 : (avatars?.length || 0);
    const mockArr = Array.from({length: 10 - countAvatars});
    const isCheckPermissionEditPhoto =  hasPermission(ROLE_ITEMS.FOREIGN_USERS_PROFILE_PERSONAL_EDIT);

    const {setToastInfo} = useContext(ToastContext);
    const {t} = useTranslation();

    const deletePhoto = async () => {
        try {
            await DeleteDescriptorService(selectAvatar);
            await dispatch(GetDescriptorsService(profileId));
            toggleIsVisibleModal();
            setToastInfo({
                isShow: true,
                type: 'success',
                text: t("success_delete_photo")
            });
            setSelectAvatar(null);
        } catch (error) {
            console.error(error);
            setToastInfo({
                isShow: true,
                type: 'error',
                text: t("error_delete_photo")
            });
        }
    }

    const changeMainPhoto = async (id) => {
        try {
            await UpdateMainDescriptorService(id, {is_main: true});
            await dispatch(GetDescriptorsService(profileId));
            await dispatch(GetPersonById(profileId));
            setToastInfo({
                isShow: true,
                type: 'success',
                text: t("success_update_photo")
            });
        } catch (error) {
            console.error(error);
            setToastInfo({
                isShow: true,
                type: 'error',
                text: t("error_update_photo")
            });
        }
    }

    useEffect(() => {
        dispatch(GetDescriptorsService(profileId))
    }, [])

    return (
        <div className="profile-photo">
            <div className="profile-photo__list">
                {avatars.length ?
                    <>
                        {avatars.slice(0, 10).map((photo) => (
                            <div className={
                                classNames(
                                    'profile-photo__avatar',
                                    'main-avatar',
                                    {
                                        'active': photo?.is_main,
                                        'profile-photo__avatar--active-hover': isCheckPermissionEditPhoto
                                    }
                                )}
                            >
                                <img src={generateMediaUrl(photo?.photo_url)} alt=""/>
                                {(!photo?.is_main && isCheckPermissionEditPhoto ) ?
                                    <div className="profile-photo__actions">
                                        <Tooltip
                                            placement="bottom"
                                            title={'Set as avatar'}
                                        >
                                            <div
                                                className="profile-photo__actions--item profile-photo__actions--edit"
                                                onClick={() => changeMainPhoto(photo.id)}
                                            >
                                                <PersonBoxIcon/>
                                            </div>
                                        </Tooltip>
                                        <Tooltip
                                            placement="bottom"
                                            title={'Remove from recognition'}
                                        >
                                            <div
                                                className="profile-photo__actions--item profile-photo__actions--delete"
                                                onClick={() => {
                                                    toggleIsVisibleModal();
                                                    setSelectAvatar(photo?.id);
                                                }}
                                            >
                                                <DeleteIcon/>
                                            </div>
                                        </Tooltip>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        ))}
                        {avatars.length < 10 ? mockArr.map(() => (
                            <div
                                className={
                                    classNames(
                                        'profile-photo__avatar',
                                            'dont-hover',
                                        {
                                            'profile-photo__avatar--active-hover': isCheckPermissionEditPhoto
                                        }
                                    )
                                }
                                >
                                <img src={PersonGray} alt=""/>
                            </div>
                        )) : null}
                    </>
                    :
                    <div
                        className={
                            classNames(
                                'profile-photo__avatar',
                                'dont-hover',
                                'active',
                                {
                                    'profile-photo__avatar--active-hover': isCheckPermissionEditPhoto
                                }
                            )
                        }
                        >
                        <img src={PersonGray} alt=""/>
                    </div>
                }
            </div>
            {isVisibleModal ? <DeleteProfilePhotoModal show={isVisibleModal} onClose={toggleIsVisibleModal}
                                                       onConfirm={deletePhoto}/> : null}
        </div>
    );
};

export default ProfilePhoto;